import { gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

const GET_JOURNEY_METRIC_USAGE = gql`
   query getJvtUsageAndLimit {
    getJvtUsageAndLimit {
      limit
      usage
    }
  }
`;

export const getUsageDetails = (usage: number = 0, limit: number = 0) => {
  if (limit === 0) {
    return {
      currentUsage: usage,
      currentUsagePercentage: 0,
    };
  }
  const currentUsagePercentage = Math.round((usage / limit) * 100);
  return {
    currentUsage: usage,
    currentUsagePercentage,
  };
};

export const useGetJourneyMetricUsage = () => {
  const options = useMemo(() => ({}), []);
  const { data, isLoading } = useGraphql(GET_JOURNEY_METRIC_USAGE, options);

  const { limit = 0, usage = 0 } = data?.getJvtUsageAndLimit || {};

  const { currentUsage, currentUsagePercentage } = getUsageDetails(usage, limit);

  return { currentUsage, currentUsagePercentage, limit: limit, isLoading };
};
